const THEMES = {
    BASIC: 'basic',
    DARK: 'dark',
    LIIGHT: 'light',
    PINK: 'pink',
    BLUE: 'blue'
  };
  
  export default THEMES;